import { fork, put, call, takeEvery, select } from 'redux-saga/effects';
import { change, formValueSelector } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import indexOf from 'lodash/indexOf';

import * as common from '../sagasCommon';
import * as SagasType from '../../constants/constant_saga_types';

import * as apiAdmin from '../../services/apiAdmin';
import * as apiBudgetType from '../../services/budget_type/api_budget_type';
import * as apiCustomTab from '../../services/custom_tab/api_custom_tab';
import * as apiDashboard from '../../services/dashboard/api_dashboard';
import * as apiIntegration from '../../services/integration/api_integration';
import * as apiPricebook from '../../services/pricebook/apiPricebook';
import * as apiReportingExchangeRate from '../../services/reporting_exchange_rate/api_reporting_exchange_rate';
import * as apiShortcut from '../../services/shortcut/api_shortcut';
import * as apiWorkflow from '../../services/workflow/api_workflow';
import * as apiXero from '../../services/xero/api_xero';

export const DropdownTypes = {
  ADDRESS_TYPE: 'address_type',
  BRAND: 'brand',
  BUDGET_TYPE: 'budget_type',
  CASH_ROUNDING: 'cash_rounding',
  CLASSIFICATION: 'classification',
  CONTACT: 'contact',
  COUNTRY: 'country',
  CREDIT_TYPE: 'credit_type',
  CURRENCY: 'currency',
  CUSTOM_FIELD: 'custom_field',
  CUSTOM_FORM: 'custom_form',
  CUSTOM_TAB: 'custom_tab',
  CUSTOMER: 'customer',
  DASHBOARD: 'dashboard',
  DELIVERY_TYPE: 'delivery_type',
  DEVICE_STATUS: 'device_status',
  DEVICE_TYPE: 'device_type',
  DEVICE: 'device',
  EMPLOYEE: 'employee',
  ENTITY_TYPE: 'entity_type',
  ENTITY: 'entity',
  FACET: 'facet',
  GROUP_TYPE: 'group_type',
  HOTKEY_GROUP: 'hotkey_group',
  HOTKEY_TEMPLATE: 'hotkey_template',
  INTEGRATION_TYPE: 'integration_type',
  INTEGRATION: 'integration',
  INVENTORY_STATUS: 'inventory_status',
  ITEM_ALTERNATE_NUMBER: 'item_alternate_number',
  ITEM_LOCATION: 'item_location',
  ITEM_MATRIX_ATTRIBUTE: 'item_matrix_attribute',
  ITEM_NUMBER_TYPE: 'item_number_type',
  ITEM: 'item',
  LANGUAGE: 'language',
  LIST: 'list',
  LOCATION: 'location',
  MATRIX_ATTRIBUTE_NAME: 'attribute_name',
  MATRIX_ATTRIBUTE_VALUE: 'attribute_value',
  ORDER_GROUP: 'order_group',
  PAYMENT_TYPE: 'payment_type',
  PAYMENT: 'payment',
  PORTLET_REPORT: 'portlet_report',
  PRICE_GROUP: 'price_group',
  PRICE_LEVEL: 'price_level',
  PRICEBOOK_REFERENCE: 'price_book_reference',
  PRINT_TEMPLATE: 'print_template',
  PROMOTION_TYPE: 'promotion_type',
  PROMOTION: 'promotion',
  REASON_CODE: 'reason_code',
  REDEMPTION_TYPE: 'redemption_type',
  REGION: 'region',
  RELATED_ENTITY_TYPE: 'related_entity_type',
  REPORT_GROUP: 'report_group',
  REPORT: 'report',
  REPORTING_PERIOD: 'reporting_period',
  ROLE: 'role',
  SALE_TRANSACTION: 'sale_transaction',
  SEARCH_DROPDOWN: 'search_dropdown',
  SEARCH_RECORD: 'csv_export',
  SEASON: 'season',
  SHIPPING_METHOD: 'shipping_method',
  SHORTCUT_GROUP: 'shortcut_group',
  SHORTCUT: 'shortcut',
  SUBSIDIARY: 'subsidiary',
  SUPPLIER: 'supplier',
  TASK_TYPE: 'task_type',
  TASK: 'task',
  TAX_EXEMPT_TYPE: 'tax_exempt_type',
  TAX_GROUP: 'tax_group',
  TAX_TYPE: 'tax_type',
  TILL_MOVEMENT_TYPE: 'till_movement_type',
  TRANSACTION_STATUS: 'transaction_status',
  TRANSACTION_TYPE: 'transaction_type',
  UOM_TYPE: 'unit_of_measure_type',
  VOID_AUDIT_TYPE: 'void_audit_type',
  WORKFLOW: 'workflow',
  XERO_ACCOUNT: 'xero_account',
  XERO_TAX_RATE: 'xero_tax_rate',
};

// const DROPDOWN_DELAY = 750;

export function* fetchDropdownSaga(feathersApp) {
  const dropdownTypes = [];

  for (const key in DropdownTypes) {
    dropdownTypes.push(`${SagasType.FETCH_DROPDOWN}.${DropdownTypes[key]}`);
  }
  yield takeEvery(dropdownTypes, callFetchDropdown, feathersApp);
}


function* callFetchDropdown(feathersApp, action) {
  // yield call(delay, DROPDOWN_DELAY);
  const { type, key, searchTerm } = action.params;

  yield common.showProgressDropdownList(key, searchTerm);
  try {
    const list = yield call(resolveDropdownCall, feathersApp, type, action.params) || [];
    yield common.doneDropdownList(key, searchTerm, list);
  } catch (error) {
    yield common.showErrorDropdownList(key, searchTerm, error);
  }
}


export function* resolveDropdownCall(feathersApp, type, params) {
  if (DropdownTypes.SEARCH_DROPDOWN === type){
    type = params.dropdown_type;
    params.type = params.dropdown_type;
  }

  switch (type) {
    case DropdownTypes.DASHBOARD:
      return yield call(apiDashboard.fetchDashboardDropdown, feathersApp, params);
    case DropdownTypes.PORTLET_REPORT:
      return yield call(apiDashboard.fetchPortletReportDropdown, feathersApp, params);
    case DropdownTypes.ITEM_ALTERNATE_NUMBER:
      return yield call(apiAdmin.fetchItemAlternateNumberDropdown, feathersApp, params);
    case DropdownTypes.PRICEBOOK_REFERENCE:
      return yield call(apiPricebook.fetchPriceBooksByReference, feathersApp, params);
    case DropdownTypes.REPORTING_PERIOD:
      return yield call(apiReportingExchangeRate.fetchReportingPeriodDropdown, feathersApp, params);
    case DropdownTypes.XERO_ACCOUNT:
      return yield call(apiXero.fetchAccountDropdown, feathersApp, params);
    case DropdownTypes.XERO_TAX_RATE:
      return yield call(apiXero.fetchTaxRateDropdown, feathersApp, params);
    case DropdownTypes.INTEGRATION_TYPE:
      return yield call(apiIntegration.fetchIntegrationTypeDropdown, feathersApp, params);
    case DropdownTypes.WORKFLOW:
      return yield call(apiWorkflow.fetchWorkflowDropdown, feathersApp, params);
    case DropdownTypes.CUSTOM_TAB:
      return yield call(apiCustomTab.fetchCustomTabDropdown, feathersApp, params);
    case DropdownTypes.SHORTCUT:
      return yield call(apiShortcut.fetchShortcutDropdown, feathersApp, params);
    case DropdownTypes.SHORTCUT_GROUP:
      return yield call(apiShortcut.fetchShortcutGroupDropdown, feathersApp, params);
    case DropdownTypes.BUDGET_TYPE:
      return yield call(apiBudgetType.fetchBudgetTypeDropdown, feathersApp, params);
    default:
      return yield call(apiAdmin.searchDocType, feathersApp, params);
  }
}

export function* refreshFormDropdownSaga(feathersApp) {
  yield takeEvery(SagasType.REFRESH_DROPDOWN, callRefreshFormDropdownSaga, feathersApp);
}
function* callRefreshFormDropdownSaga(feathersApp, action) {
  const { formId, params } = action;

  if (!formId || !params) {
    return;
  }

  for (const key in params) {
    const options = params[key];

    if (!options) {
      continue;
    }

    // "filter" is the couchdb selector filter;
    // "field" is the field representing the dropdown on the form
    yield fork(refreshOneDropdown, feathersApp, formId, key, options);
  }
}


function* refreshOneDropdown(feathersApp, formId, key, options) {

  const searchTerm = null;
  const { field } = options;

  // clears the form field value
  // yield put(change(formId, field, null));

  // Show busy icon on dropdown
  yield common.showProgressDropdownList(key, searchTerm);

  // Pick up the dropdown values
  const list = yield call(resolveDropdownCall, feathersApp, key, options);

  // Show fetched data
  yield common.doneDropdownList(key, searchTerm, list);

  // Remove selected values that are not part of the dropdown results
  if (field) {
    const fieldValue = yield select(formValueSelector(formId), field);

    if (!isEmpty(fieldValue)) {
      const listIds = list.reduce((arr, listItem) => {
        if(listItem.id){
          arr.push(listItem.id);
        }
        return arr;
      }, []);
      const newIds = filter(fieldValue, (obj) => {
        return indexOf(listIds, obj.id) > -1;
      });
      if (isEmpty(newIds)) {
        yield put(change(formId, field, null));
      } else {
        yield put(change(formId, field, newIds));
      }
    }

  }


}
